// Mirrors each PartyCharacteristic subclass's `card_sort_date` (see app/models/party_characteristic/*.rb),
// so cards keep the backend's most-recent-first order after a single card is patched in place.
const CARD_SORT_DATE_FIELDS = {
  children: 'dob',
  criminal_histories: 'incident_date',
  detention_histories: 'initiated_date',
  education_histories: 'start_date',
  immigration_benefits: 'initiated_date',
  immigration_proceedings: 'initiated_date',
  immigration_statuses: 'date_obtained',
  immigration_status_histories: 'date_obtained',
  job_histories: 'start_date',
  narratives: 'entry_date',
  parents: 'dob',
  passports: 'issue_date',
  residence_histories: 'start_date',
  siblings: 'dob',
  spouses: 'marriage_date',
  travel_histories: 'entry_date',
}

// Returns a new array ordered most-recent-first by `characteristic`'s date field, leaving
// `collection` untouched so the underlying state array keeps a stable reference/order.
export const sortCharacteristicCards = (characteristic, collection) => {
  const dateField = CARD_SORT_DATE_FIELDS[characteristic]

  if (!dateField || !Array.isArray(collection)) return collection

  return [...collection].sort((a, b) => {
    if (!a[dateField]) return 1
    if (!b[dateField]) return -1

    return new Date(b[dateField]) - new Date(a[dateField])
  })
}
